import React, { useEffect } from "react";
import { YhPageHeader } from "../../../../../components/YhPageHeader";
import { InfoBox } from "./InfoBox";
import { ActionTypeEnum, useDetailModel } from "./detailModel";

import { AccountSearchBox } from "./account/SearchBox";                 // 账户列表检索区
import { AdjustSearchBox } from "./adjust/SearchBox";                   // 调额记录检索区
import { BIllSearchBox } from "./bill/SearchBox";                       // 账单列表检索区
import { LogSearchBox } from "./log/SearchBox";                         // 操作日志检索区
import { RechargeSearchBox } from "./recharge/SearchBox";               // 充值记录检索区
import { TransferSearchBox } from "./transfer/SearchBox";               // 转账记录检索区
import { WriteoffSearchBox } from "./writeoff/SearchBox";               // 核销记录检索区

import { AccountDataBox } from "./account";                             // 账户列表展示区
import { AdjustDataBox } from "./adjust";                               // 调额记录展示区
import { BillDataBox } from "./bill";                                   // 账单列表展示区
import { LogDataBox } from "./log";                                     // 操作日志展示区
import { RechargeDataBox } from "./recharge";                           // 充值记录展示区
import { TransferDataBox } from "./transfer";                           // 转账记录展示区
import { WriteoffDataBox } from "./writeoff";                           // 核销记录展示区
import { orgService } from "../../../../base/org/orgService";
import { customerService } from "../../../../base/customer/customerService";
import { dictService } from "../../../../base/dict/dictService";
import appService from "../../../../base/app/appService";
import { beService } from "../../../../base/be/beService";
import { labelsType } from "../../../../cash/pay/cashPayModel";
import { supplierService } from "../../../../base/supplier/supplierService";
/**
 * 检索区判断
 */
const DetailSearchBox = () => {
    const { actionType, } = useDetailModel();
    switch (actionType) {
        case ActionTypeEnum.ACCOUNT:
            return <AccountSearchBox />;
        case ActionTypeEnum.ADJUST_LIST:
            return <AdjustSearchBox />;
        case ActionTypeEnum.BILL_LIST:
            return <BIllSearchBox />;
        case ActionTypeEnum.LOG_LIST:
            return <LogSearchBox />;
        case ActionTypeEnum.RECHARGE_LIST:
            return <RechargeSearchBox />;
        case ActionTypeEnum.TRANSFER_LIst:
            return <TransferSearchBox />;
        case ActionTypeEnum.WRITEOFF_LIST:
            return <WriteoffSearchBox />;
        default:
            return <></>
    }
}

/**
 * 内容区判断
 */
const DetailDataBox = () => {
    const { actionType, } = useDetailModel();
    switch (actionType) {
        case ActionTypeEnum.ACCOUNT:
            return <AccountDataBox />;
        case ActionTypeEnum.ADJUST_LIST:
            return <AdjustDataBox />;
        case ActionTypeEnum.BILL_LIST:
            return <BillDataBox />;
        case ActionTypeEnum.LOG_LIST:
            return <LogDataBox />;
        case ActionTypeEnum.RECHARGE_LIST:
            return <RechargeDataBox />;
        case ActionTypeEnum.TRANSFER_LIst:
            return <TransferDataBox />;
        case ActionTypeEnum.WRITEOFF_LIST:
            return <WriteoffDataBox />;
        default:
            return <></>
    }
}

export const SupplierAccountDetail = () => {
    const {
        setOrgDs,
        setBeDs,
        setPayMethodLabels,
        setAppDs,
        setPayMethodDs,
        supplierCode,
        closeNav,
        loadSummaryData,
    } = useDetailModel()

    useEffect(() => {

        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        appService.appDs({}).then(ds => setAppDs(ds));
        dictService.accountTreeOne("pay-method").then(ds => setPayMethodDs(ds))
        dictService.dictItemDs("settle-type").then(ds => {
            let obj: labelsType = {}
            ds.forEach(item => {
                obj[item.value] = item.label
            })
            setPayMethodLabels(obj)
        })
        if (!supplierCode) {
            return closeNav("2-2-1");
        }
    }, []);

    useEffect(() => {
        loadSummaryData()

    }, [supplierCode]);

    return (
        <>
            <YhPageHeader title="供应商账户详情" />
            <InfoBox />
            <DetailSearchBox />
            <DetailDataBox />
        </>
    )
}
